import { useRuntimeConfig } from 'nuxt/app'
import { Route } from '~/apps/pu-links/domain/Route'
import { SearchLinkGenerator } from '../apps/url/generators/SearchLinkGenerator'
import { SearchFiltersUrl } from '../apps/url/search-filters/SearchFiltersUrl'
import { getDefaultWithinForLocale } from './geo/distance-units'
import { GeoCoordinates } from './geolocation/schema'

export default function generateNearMeUrl(
  category: string,
  query: Route['query'],
  point: GeoCoordinates,
  locale: string = 'en-gb',
) {
  const urlGenerator = new SearchLinkGenerator()
  const config = useRuntimeConfig()
  const defaultMiles = config.public.defaultNearMeWithinRange
  const defaultInLocaleUnit = getDefaultWithinForLocale(defaultMiles, locale)
  const area = {
    lat: point.lat,
    lng: point.lng,
    isEmptyPoint: false,
  }
  return urlGenerator.getUrlData({
    category,
    excludeType: 'nearMe',
    filters: {
      ...SearchFiltersUrl.urlToFilters(query),
      area,
      within: defaultInLocaleUnit,
    },
  })
}
